import { REQUEST_STATUSES } from "@/constants/index.js";

import * as types from "./types.js";

const initialState = {};

const elementInitialState = {
  elements: [],
  status: REQUEST_STATUSES.IDLE,
  err: null,
};

export const contentElementsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CONTENT_ELEMENTS: {
      const { propertyId, mediaItemId, elements, status, err } = action.payload;
      const key = mediaItemId ? `${propertyId}${mediaItemId}` : `${propertyId}`;

      return {
        ...state,
        [key]: {
          elements,
          status,
          err,
        },
      };
    }
    case types.REFRESH_CONTENT_ELEMENTS: {
      const { propertyId, mediaItemId, element } = action.payload;
      const key = mediaItemId ? `${propertyId}${mediaItemId}` : `${propertyId}`;
      let { elements = [] } = state[key] || {};
      elements = elements.map((el) => (el.id === element.id ? element : el));

      return {
        ...state,
        [key]: {
          ...elementInitialState,
          ...(state[key] || {}),
          elements,
        },
      };
    }
    case types.SET_CONTENT_ELEMENTS_REQUEST_STATUS: {
      const { propertyId, mediaItemId, status } = action.payload;
      const key = mediaItemId ? `${propertyId}${mediaItemId}` : `${propertyId}`;

      return {
        ...state,
        [key]: {
          ...elementInitialState,
          ...(state[key] || {}),
          status,
        },
      };
    }
    case types.RESET_CONTENT_ELEMENTS: {
      const { propertyId, mediaItemId } = action.payload;

      if (propertyId && mediaItemId) {
        return { ...state, [`${propertyId}${mediaItemId}`]: elementInitialState };
      }

      if (propertyId) {
        return { ...state, [`${propertyId}`]: elementInitialState };
      }

      return state;
    }
    case types.DELETE_CONTENT_ELEMENTS: {
      const { elementId } = action.payload;

      const copy = {};
      for (const key in state) {
        const elements = state[key].elements.filter((el) => el.id !== elementId);
        if (state[key].elements.length !== elements.length) {
          copy[key] = { ...state[key], elements };
        } else {
          copy[key] = state[key];
        }
      }

      return copy;
    }
    default:
      return state;
  }
};
